// Deliberate stub: global app-status messaging is temporarily disabled while
// status feedback is handled by route-level loading states and network UI.
// Restore this only when a dedicated app-wide status flow exists.
export function AppStatusModal() {
  return null;
}
